import {OggettoConfig} from "../../../app/shared/_services/dynamic-crud.service";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {generateExcel} from "../../Utility/Utility";
import {Scaduta} from "../../Utility/DateUtility";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";

export function Prodotti() {
  var OBJ: OggettoConfig = {
    Id: "catalogo-frigo",
    RestRoute: "/prodotti",
    ListDefaultFilter: {tipo: 68},
    ListResponseHasData: true,
    listTitle: "Catalogo",
    HasAddList: {func:()=>true},
    Buttons: [
    ],
    ListMap: (list) => list.map(coupon => {
      return {...coupon}
    }),
    Map: (x) => {
      return {...x, prezzo: x.prezzi?.length ? x.prezzi[0].prezzo : 0}
    },
    OnSaveMap: (x) => {
      return {...x, prezzi: [{um: 64, prezzo: x.prezzo, iva: 22,}], tipo: 50}
    },
    PrintHeaders:[
      CampoAggiuntivo.InputField("Codice", "prodotto", "text", "", {modificabile: false, printable:true}),
      CampoAggiuntivo.InputField("Descrizione", "descrizioneBreve", "text", "", {modificabile: false, printable:true}),
      {nome: "Scheda Prodotto", oggetti: ["scheda"], type: 'html', func: (coupon, parent?) => coupon.id_scheda ? `https://customer.klimaitalia.it/api/file/image/${coupon.id_scheda}`: ''},
      {nome: "Immagine Prodotto", oggetti: ["scheda"], type: 'html', func: (coupon, parent?) => coupon.id_immagine ? `https://customer.klimaitalia.it/api/file/image/${coupon.id_immagine}`: ''}
    ],
    Headers: [
      CampoAggiuntivo.InputField("Codice", "prodotto", "text", "", {modificabile: false, printable:true}),
      CampoAggiuntivo.InputField("Descrizione", "descrizioneBreve", "text", "", {modificabile: false, printable:true}),
      {
        nome: "Scheda Prodotto", oggetti: ["scheda"], type: 'html', func: (coupon, parent?) =>
          coupon.id_scheda? `<a href="https://customer.klimaitalia.it/api/file/image/${coupon.id_scheda}" class="link "><i class="far fa-save"></i></a>`: `<a href="javascript:void(0)" class="link "><i class="far fa-save" tooltip="L'immagine non è stata trovata."></i></a>`
      },
      {
        nome: "Immagine Prodotto", oggetti: ["scheda"], type: 'html', func: (coupon, parent?) =>
          `<a href="https://customer.klimaitalia.it/api/file/image/${coupon.id_immagine}" class="link "><i class="far fa-save"></i></a>`
      }
    ],
    MenuItems: [
      {
        path: "/shared/dynamiclist/catalogo-frigo",
        title: "Catalogo",
        icon: "fa-solid fa-qrcode",
        class: "",
        capacita: [],
        ruoliOperativi:["S", "DM", "NAM"]
      },
    ]
  }
  return OBJ;
}
